import Component from "ips/ac/Component";
import CoreComponent from "sap/ui/core/Component";
import JSONModel from "sap/ui/model/json/JSONModel";
import ODataModel from "sap/ui/model/odata/v4/ODataModel";
import Model from "sap/ui/model/Model";
import ResourceModel from "sap/ui/model/resource/ResourceModel";
import ResourceBundle from "sap/base/i18n/ResourceBundle";
import ManagedObject from "sap/ui/base/ManagedObject";
import ODataContextBinding from "sap/ui/model/odata/v4/ODataContextBinding";
import ODataListBinding from "sap/ui/model/odata/v4/ODataListBinding";

export default class Util {
  public static getComponent(): Component {
    const component = CoreComponent.getComponentById("windoflow_component") as Component;

    if(!component) {
      throw new Error("Component not found");
    }

    return component;
  }

  public static getText(key: string, args?: any[]) {
    const resourceModel = Util.getComponent().getModel("i18n") as ResourceModel;
    const bundle = resourceModel.getResourceBundle() as ResourceBundle;
    return bundle.getText(key, args);
  }

  public static getIpsConfig(): JSONModel {
    return Util.getComponent().getModel("ips_config") as JSONModel;
  }

  public static getModel(name: string): Model {
    return Util.getComponent().getModel(name);
  }

  public static getAppModel() {
    return Util.getModel("app");
  }

  public static getPrivateApi(): string {
    return Util.getIpsConfig().getProperty("/RestApi");
  }

  public static getUserRoles() {
    return Util.getAppModel().getProperty("/UserRoles");
  }

  // TODO move to user
  public static hasRole(role: string): boolean {
    return Util.getUserRoles().hasOwnProperty(role);
  }

  public static getODataModel(): ODataModel {
    return Util.getComponent().getModel() as ODataModel;
  }

  public static createModelPath(path?: string, object?: any): string {
    if (!path || !object) {
      return;
    }

    path = path.startsWith("/") ? path : `/${path}`;
    return path + Util.getODataModel().getKeyPredicate(path, object);
  }

  public static findParentControl(className: string, source: ManagedObject): ManagedObject {
    let oNode = source.getParent();
    const classNames = Array.isArray(className) ? className : [className];

    while (
      oNode !== null &&
      classNames.indexOf(oNode.getMetadata().getName()) === -1
      ) {
      oNode = oNode.getParent();
    }
    return oNode;
  }

  public static findParentView(source: ManagedObject) {
    return Util.findParentControl("sap.ui.core.mvc.XMLView", source);
  }

  public static refreshSharedResource(path: string) {
    const aBindings = Util.getODataModel().getAllBindings();
    const aFiltered = aBindings.filter(b => b.getPath() === path && b.bSharedRequest);

    const seen = new Set();
    const aToRefresh = aFiltered.filter(b => {
      if (seen.has(b.oCache)) {
        return false;
      }
      seen.add(b.oCache);
      return true;
    });

    aToRefresh.forEach(b => b.refresh());
  }

  public static searchForContext(sGuid: string) {
    Util.getODataModel().getAllBindings();

    const aBindings = Util.getODataModel().getAllBindings().filter(oBinding => oBinding.isRoot() && oBinding.isA("sap.ui.model.odata.v4.ODataContextBinding"));
    const oContext = aBindings.find((oBinding) => oBinding.getBoundContext()?.getObject().Guid === sGuid);
    return oContext?.getBoundContext();
  }


  public static searchForAllContexts(sGuid: string, aPaths: any[]) {
    const aBindings = Util.getODataModel().getAllBindings()
      .filter(oBinding => oBinding.isRoot() && (oBinding instanceof ODataContextBinding || (oBinding instanceof ODataListBinding && aPaths.includes(oBinding.getPath()))));
    let oContext;
    for (const oBinding of aBindings) {
      if (oBinding instanceof ODataContextBinding && oBinding.getBoundContext().getObject()?.Guid === sGuid) {
        oContext = oBinding.getBoundContext();
        break;
      } else if (oBinding instanceof ODataListBinding) {
        oContext = oBinding.getAllCurrentContexts().find((oContext) => oContext.getProperty("Guid") === sGuid);
        if (oContext) {
          break;
        }
      }

    }
    return oContext;
  }


}